import { anyOf, arrayOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

import type { PersonalizationExplainerDimensionActions, PersonalizationExplainerAction } from "./types";

const isNull = (v: unknown): v is null => v === null;

const isActionParameterValue = anyOf(string, number, boolean, isNull);

const isPersonalizationExplainerAction = objectOf<PersonalizationExplainerAction>({
  action_strength: number,
  personalization_strength: number,
  action_profile: number,
  percentage_action_availability: number,
  number_times_chosen: number,
  percentage_time_chosen: number,
  action_parameters: recordOf({ value: isActionParameterValue }),
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActionsResult =
  anyOf(
    objectOf<PersonalizationExplainerDimensionActions>({
      report_dt: string,
      best_action_ids: arrayOf(number),
      hover_main_action_param_to_show: string,
      hover_other_action_params_to_show: arrayOf(string),
      table_params_columns: arrayOf(string),
      data: recordOf({ value: isPersonalizationExplainerAction }),
    }),
    nullValidation
  );
